//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// dto_for_UpdateStatePracticeAdoptions
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class dto_for_UpdateStatePracticeAdoptions {

    practicesByIdToAdd = []
    practicesByIdToRemove = []

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    //constructor(){
    //};
}